import { checkStatus, parseJSON, setPostHeaders } from "@utils/fetch";
import { updateMailIdInWidgetData, WidgetFormType } from "database/supabase/freeTools";
import React, { useState } from "react";
import { useSnackbar } from "react-simple-snackbar";

const validateEmail = (mailId: string): boolean => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(mailId);
};

const WASendmail: React.FC<{ data: any }> = ({ data }) => {
    const [mailId, setMailId] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [openSnackbar] = useSnackbar();
    const [openErrorSnackbar] = useSnackbar({
        style: {
            backgroundColor: "#DC2626",
        },
    });
    const onSubmit: React.FormEventHandler<HTMLFormElement> = async (event) => {
        event.preventDefault();

        if (isLoading) return;

        if (!validateEmail(mailId)) {
            openErrorSnackbar("Your email address looks invalid. Please enter a valid address.", 9000);
            return;
        }

        setLoading(true);
        try {
            const newData = {
                number: data?.wanumber,
                name: data?.brandName,
                tag: data?.statusTag,
                image: data?.logo,
                text: data?.welcomeText,
                radio: data?.buttonPosition,
                message: data?.triggerMsg,
                ...(data.widgetStyle === "v1"
                    ? {
                          question: data?.question,
                          options: data?.options,
                      }
                    : {
                          customQuestion: data?.customQuestion,
                          startChatBtnTxt: data?.startChatBtnTxt,
                      }),
                version: data.widgetStyle,
                widgetPositionMarginX: data.widgetPositionMarginX,
                widgetPositionMarginY: data.widgetPositionMarginY,
            };

            await fetch("/api/v1/sendCode", setPostHeaders({ mailId, data: newData }))
                .then(checkStatus)
                .then(parseJSON)
                .then((res) => {
                    setMailId("");
                    const { responseText = "Thanks for your interest, we will contact you soon." } = res;
                    openSnackbar(responseText, 5000);
                });
        } catch (error) {
            openSnackbar("OOPS! Something went wrong, please send your message to team@gallabox.com", 10000);
        } finally {
            setLoading(false);

            const payload: Pick<WidgetFormType, "wanumber" | "mailId"> = { wanumber: data?.wanumber, mailId: mailId };

            updateMailIdInWidgetData(payload);
        }
    };
    const getMailId: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        setMailId(event.target.value);
    };
    return (
        <div className="bg-white w-full">
            <p className="text-center p-2 font-light text-sm">(OR)</p>
            <div className="text-center text-base font-semibold">Get the Code through Email</div>
            <div className="text-center my-2">
                <form onSubmit={onSubmit}>
                    <input
                        data-cy="mail-input"
                        type="text"
                        value={mailId}
                        className="border-2 text-sm rounded w-60"
                        style={{ margin: "0", padding: "10px" }}
                        placeholder="Enter your Email ID"
                        onChange={(e) => getMailId(e)}
                    />
                    <button data-cy="getWidget-code-btn" disabled={isLoading} type="submit" className="bg-blue-600 focus:outline-none rounded-lg text-sm text-white p-2 m-2">
                        {isLoading ? "Sending..." : "Get Widget Code"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default WASendmail;
